export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?2e62b6565e8fb8e62ffcb57ab4fefbfb";